import qs from 'qs';
import instance, { PPR_API_URL } from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IProjectEquipment } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getProjectEquipmentList = (params: IDynamicTableParams): Promise<IProjectEquipment[]> => {
  return instance(true, PPR_API_URL)
    .get('/dictionary/projectEquipment/list', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};

export const getProjectEquipmentAvailableColumns = (): Promise<IAvailableColumnModel[]> => {
  return instance(true, PPR_API_URL)
    .get('/dictionary/projectEquipment/availableColumns')
    .then((response) => response.data);
};

export const getProjectEquipmentAvailableGroupColumns = (): Promise<IAvailableGroupColumnModel[]> => {
  return instance(true, PPR_API_URL)
    .get('/dictionary/projectEquipment/availableGroupColumns')
    .then((response) => response.data);
};

export const archiveProjectEquipment = (equipmentId: string, isDeleted: boolean) => {
  return instance(true, PPR_API_URL)
    .post(`/dictionary/projectEquipment/deleted/${equipmentId}`, { isDeleted })
    .then((response) => response.data);
};
